import React from 'react';
import { Form, Row, Col, Card, Input, Select } from 'antd';

const { Option } = Select;

const CarData: React.FC = () => (
  <Card title="Datos del vehículo">
    <Row align="middle" wrap gutter={[16, 8]}>
      <Col xs={24} md={12} lg={8}>
        <Form.Item
          label="Año"
          name={['car_policy_1', 'year']}
          rules={[
            {
              required: true,
              type: 'string',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12} lg={8}>
        <Form.Item
          label="Marca"
          name={['car_policy_1', 'brand']}
          rules={[
            {
              required: true,
              type: 'string',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12} lg={8}>
        <Form.Item
          label="Modelo"
          name={['car_policy_1', 'model']}
          rules={[
            {
              required: true,
              type: 'string',
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12} lg={8}>
        <Form.Item
          label="Número de Serie"
          name={['car_policy_1', 'serial_number']}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12} lg={8}>
        <Form.Item label="Placas" name={['car_policy_1', 'plates']}>
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12} lg={8}>
        <Form.Item label="Otros" name={['car_policy_1', 'others']}>
          <Input />
        </Form.Item>
      </Col>
      <Col xs={24} md={12} lg={8}>
        <Form.Item label="Cobertura" name={['car_policy_1', 'coverage']}>
          <Select placeholder="--- Seleccionar --- ">
            <Option value="amplia">Amplia</Option>
            <Option value="limitada">Limitada</Option>
            <Option value="resp_civil">Resp. civil</Option>
          </Select>
        </Form.Item>
      </Col>

      <Form.Item name={['car_policy_1', 'id']} hidden>
        <Input />
      </Form.Item>
    </Row>
  </Card>
);

export default CarData;
